var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { BaseTable } from './BaseTable';
var BodyTable = /** @class */ (function (_super) {
    __extends(BodyTable, _super);
    function BodyTable(props) {
        return _super.call(this, props) || this;
    }
    BodyTable.prototype.render = function () {
        var _a = this.props, columns = _a.columns, data = _a.data, fixed = _a.fixed, getRowKey = _a.getRowKey, handleBodyScroll = _a.handleBodyScroll, expander = _a.expander;
        var table = this.context.table;
        var saveRef = table.saveRef;
        var _b = table.props, useFixedHeader = _b.useFixedHeader, scroll = _b.scroll;
        var bodyStyle = {};
        if (scroll.x) {
            bodyStyle.overflowX = 'scroll';
        }
        if (scroll.y) {
            useFixedHeader = true;
            bodyStyle.maxHeight = scroll.y;
            bodyStyle.overflowY = 'scroll';
        }
        if (fixed) {
            var refName = void 0;
            if (columns[0].fixed === 'left' || columns[0].fixed === true) {
                refName = 'fixedColumnsBodyLeft';
            }
            else if (columns[0].fixed === 'right') {
                refName = 'fixedColumnsBodyRight';
            }
            delete bodyStyle.overflowX;
            return (React.createElement("div", { style: bodyStyle, ref: saveRef(refName), onScroll: handleBodyScroll },
                React.createElement(BaseTable, { columns: columns, expander: expander, fixed: fixed, getRowKey: getRowKey, hasHead: !useFixedHeader, hasBody: true, data: data })));
        }
        return (React.createElement("div", { style: bodyStyle, ref: saveRef('bodyTable'), onScroll: handleBodyScroll },
            React.createElement(BaseTable, { columns: columns, expander: expander, fixed: fixed, getRowKey: getRowKey, hasHead: !useFixedHeader, hasBody: true, data: data })));
    };
    BodyTable.contextTypes = {
        table: PropTypes.any,
    };
    return BodyTable;
}(Component));
export { BodyTable };
